/**
 * Feed Plugin
 * create a feed of items
 */

var Feed = function(element, options){
    this.element = element;
    this.$element = $(element);
    this.settings = $.extend({}, this.defaults, options);
    this.init();
};
 
Feed.prototype = {
    
    // shorthand for using prototype
    constructor : Feed,
    
    // default options
    defaults : {
        limit : 5,
        url : '',
        data : '',
        identifier : 'id',
        height : 500,
        refresh : 30000,
        updateOnLoad : false,
        animationSpeed : 500,
        onRefresh : function(){}
    },
    
    init : function(){  
        var _this = this;

        _this.$element.find('.js-get-feed-items').on('click', function(e){
            _this.updateFeed();
            e.preventDefault();
        });

        if ( _this.settings.refresh ) {
            setInterval(function(){
                _this.updateFeed('recent');
            }, _this.settings.refresh);
        }

        if ( _this.settings.updateOnLoad ){
            _this.updateFeed('recent');
        }
    },

    updateFeed : function(type){
        var _this = this,
            $container = _this.$element,
            $list = _this.$element.find('.activity-list'),
            _limit = _this.settings.limit,
            _identifier = _this.settings.identifier,
            _type = type || null,
            _data = _this.settings.data;

        if ( _type === 'recent' ) _data += '&most_recent=1';

        if ( ! $list.hasClass('is-loading') ){
            $list.addClass('is-loading');

            if ( $list.find('.activity-item').length ){
                var $item = $container.find('.activity-item:' + (_type == 'recent' ? 'first' : 'last'));

                if ( Array.isArray(_identifier) ){
                    _identifier.forEach(function(currIdentifier){
                        _data += '&' + currIdentifier + '=' + $item.attr('data-' + currIdentifier);
                    });
                } else {
                    _data += '&' + _identifier + '=' + $item.attr('data-' + _identifier);
                }

                _data += '&items=' + _limit;

                _this.getFeedItems(_data, _type);
            } else {
                _this.getFeedItems(_data);
            }
        }
    },

    // ajax call
    getFeedItems : function(data, type){
        var _this = this,
            $container = _this.$element,
            $list = $container.find('.activity-list');

        $.fn.qpost({
            url : _this.settings.url,
            data : data,
            success : function(data){
                if ( data ){
                    if ( typeof data.stream !== 'undefined' && data.stream !== null && data.stream.length > 0 ){
                        var dataLength = data.stream.length,
                            listHeight = $container.outerHeight();

                        $container.addClass('has-overflow');

                        // Apply a max-height for scrolling
                        if ( listHeight >= _this.settings.height ){
                            $container.css('max-height', $container.outerHeight() + 'px');
                        } else {
                            $container.css('max-height', _this.settings.height + 'px');
                        }

                        $.each(data.stream, function(index, item){
                            var _html = item.html,
                                $html = $(_html);   
                            
                            $html.addClass('is-hidden');

                            setTimeout(function(){
                                var scrollHeight = $container.prop('scrollHeight'),
                                    position = (type == 'recent' && $list.find('.activity-item').length ? '.activity-item:first' : '.js-last-activity-item');
                                    
                                $container.find(position).before($html);

                                setTimeout(function(){
                                    $html.removeClass('is-hidden');
                                }, 10);

                                if ( type !== 'recent' ){
                                    $container.scrollTop(scrollHeight);
                                }

                                if ( (index + 1) == dataLength ){
                                    $list.removeClass('is-loading');
                                }
                            }, index * _this.settings.animationSpeed);
                        });
                    } else {
                        $list.removeClass('is-loading');
                    }

                    _this.settings.onRefresh.call(this, _this.$element, data, type);
                }
            }
        });
    }
};

$.fn.feed = function ( options ) {
    this.each(function() {
        if ( !$.data( this, "qg_feed" ) ) {
            $.data( this, "qg_feed", new Feed( this, options ) );
        }
    });

    // chain jQuery functions
    return this;
};
